import { Button } from '@mui/material'
import { CSSProperties, useState } from 'react'
import { HighFive, Player } from '../types'
import GetInspiredDialog from './GetInspiredDialog'
import _ from 'lodash'

const teammateHeaderStyle: CSSProperties = {
  marginTop: '10px',
  marginBottom: '2px',
  textAlign: 'center',
}

interface Props {
  highFives: HighFive[]
  player: Player
  teammate: Player
}

export function HighFiveText({ highFives, player, teammate }: Props) {
  const latestReceivedHighFive = _.findLast(highFives, (h) => h.senderId === teammate.id)
  const latestSentHighFive = _.findLast(highFives, (h) => h.senderId === player.id)
  const [selectedVideoFileName, setSelectedVideoFileName] =
    useState<null | string>(null)

  const renderVideoButton = ({
    isSentVideo,
    videoFileName,
    teammate,
  }: {
    isSentVideo: boolean
    videoFileName: string
    teammate: Player
  }) => {
    return (
      <Button
        style={{ textTransform: 'none' }}
        onClick={() => setSelectedVideoFileName(videoFileName)}
      >
        {isSentVideo
          ? `You sent a video high five!`
          : `${teammate.firstName} sent a video high five! 👋`}
      </Button>
    )
  }
  return (
    <div style={teammateHeaderStyle}>
      <h4 style={{ marginBottom: 5 }}>
        {latestReceivedHighFive
          ? latestReceivedHighFive.videoFileName
            ? renderVideoButton({
                isSentVideo: false,
                videoFileName: latestReceivedHighFive.videoFileName,
                teammate,
              })
            : `${teammate.firstName} says "${latestReceivedHighFive.message}"`
          : `Your teammate this round is ${teammate.firstName}!`}
        <br />
        {latestSentHighFive
          ? latestSentHighFive.videoFileName
            ? renderVideoButton({
                isSentVideo: true,
                videoFileName: latestSentHighFive.videoFileName,
                teammate,
              })
            : `You say "${latestSentHighFive.message}"`
          : null}
      </h4>
      {selectedVideoFileName ? (
        <GetInspiredDialog
          videoFileName={selectedVideoFileName}
          onCancel={() => setSelectedVideoFileName(null)}
        />
      ) : null}
    </div>
  )
}
